import axiosInstance, { endpoints } from 'src/utils/axios';

export async function createReview(formData: any, book_id: string) {
  const URL = endpoints.public.create_review(book_id);

  const { data } = await axiosInstance.post(URL, formData);

  return data;
}
